import Pages from "src/constants/pages";
import { ArrangeHorizontalSquare, CardAdd, CardTick1, Ticket, Money, Sun, Setting, Money2, Wallet3, Gift } from "iconsax-react";

const index = [
	{
		title: "پنل کاربری",
		path: Pages.UserPanel,
		// path: DEFAULT_DASHBOARD_ROUTE,
		icon: Setting
	},
	{
		title: "تسهیلات",
		path: Pages.Facilities,
		// path: "/main/requests/newRequest",
		icon: CardAdd
	},
	{
		title: "اعتبارات",
		path: Pages.GiftCredit,
		// path: "/main/gift-credit",
		icon: Money
	},
	{
		title: "انتقال اعتبار",
		path: Pages.CreditTransfer,
		// path: "/main/requests/transfer",
		icon: ArrangeHorizontalSquare
	},
	{
		title: "جت کلاب",
		path: Pages.JetClub,
		// path: "/main/club",
		icon: Sun
	},
	{
		title: "کیف پول",
		path: Pages.Wallet,
		// path: "/main/club",
		icon: Wallet3
	},
	{
		title: "جت کارت",
		path: Pages.JetCard,
		icon: Gift
	},
	{
		title: "تراکنش ها",
		path: Pages.Transactions,
		// path: "/main/transactions",
		icon: CardTick1
	},
	{
		title: "درخواست پشتیبانی",
		path: Pages.Tickets,
		// path: "/main/tickets",
		icon: Ticket
	},
	{
		title: "پرداخت اقساط",
		// path: "/loan-repayment",
		path: Pages.LoanPayment,
		// path: "/payInstallment/0",
		icon: Money2
	}
];
export default index;